module.exports = "https://static.energy5.com/_next/static/images/safeAndReliable-cc0a02e596bb87e8bbd28d6b9cb4a6b2.png";